import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_DATA} from '../../../api';
import $ from "jquery";
import cogoToast from "cogo-toast";
import moment from "moment";
import {capitalize} from "../../../utils/capitalize";
import 'react-quill/dist/quill.snow.css';
import formatNumber from "../../../utils/formatNumber";
import {getInvestmentReport} from "../../../api/app";

const Investment = () => {

    document.title = "Investment";

    const token = localStorage.getItem('jwtToken');
    const [reset, setReset] = useState(new Date().getTime());

    useEffect(() => {
        getInvestmentReport().then((response) => {
            if(!response.error) {
                $('#total-count').text(`K${formatNumber(response.payload?.disbursement?.total, "digit")}`);
                $('#total-Amount').text(`K${formatNumber(response.payload?.total?.amount, "digit")}`);
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#investment').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Investment Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "investment",
                        fieldname: "id_number",
                        pageSize: data.start,
                        populate: [
                            {
                                path: "user",
                                model: "user"
                            }
                        ],
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];

                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return capitalize(data?.user?.name);
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `K${formatNumber(data?.amount)}`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return 0;
                        return `${data?.investment?.equity}%`;
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return 0;
                        return {
                            "paid" : `<span class="badge badge-success tx-white">Paid</span>`,
                            "failed" : `<span class="badge badge-danger tx-white">Paid</span>`,
                            "error" : `<span class="badge badge-danger tx-white">Error</span>`,
                            "pending" : `<span class="badge badge-warning tx-white">Pending</span>`,
                        }[data.status];
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.createdAt).format("Do MMM, YYYY");
                    },
                    "targets": 5
                }
            ]
        });

        $('#investment tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            const { raw } = d;

            const rows = [
                row('Investment:', [
                    '<strong>Company</strong>: ' +capitalize(raw.investment.company.name),
                    '<strong>Sector</strong>: ' +capitalize(raw.investment.sector),
                    '<strong>Description</strong>: ' + raw.investment.description,
                    '<strong>Amount<strong/>: K' + formatNumber(raw.investment.amount),
                    '<strong>Type</strong>: ' + capitalize(raw.investment.type),
                ].join('<br/>')),
                row('Investor:', [
                    '<strong>Name</strong>: ' +capitalize(raw.investor.name),
                    '<strong>Mobile Number</strong>: ' +raw.investor.mobile_number,
                    '<strong>Email Address</strong>: ' +raw.investor.email,
                ].join('<br/>')),
                row('Transaction:', [
                    '<strong>TXN Number</strong>: ' +raw.transaction.txn_number.toUpperCase(),
                    '<strong>Payment Method</strong>: ' +raw.transaction.gateway,
                    '<strong>Status</strong>: ' +`<span class="badge badge-success tx-white">${capitalize(raw.transaction.status)}</span>`,
                ].join('<br/>'))
            ].filter(Boolean).join('');

            return `
                <table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">
                  ${rows}
                </table>
              `;

            function row(label, html) {
                return `
                  <tr>
                    <td class="tx-semibold">${label}</td>
                    <td>${html}</td>
                  </tr>
                `;
            }
        }

        return () => {
            table.destroy();
        }

    }, []);

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Investment</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Investment</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-sm-6 col-lg-6">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Investment</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-count" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="total-gender" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>
                    <div className="col-sm-6 col-lg-6 mg-t-10 mg-sm-t-0">
                        <div className="card card-body">
                            <h6 className="tx-uppercase tx-11 tx-spacing-1 tx-primary tx-semibold mg-b-8">Total Amount Raised</h6>
                            <div className="d-flex d-lg-block d-xl-flex align-items-end">
                                <h3 id="total-Amount" className="tx-normal tx-rubik mg-b-0 mg-r-5 lh-1">0</h3>
                            </div>
                            <span id="month-current" className="tx-11 tx-color-02 mg-b-0 mg-t-5">---</span>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Investment List</h6>
                                <div className="d-flex tx-18">
                                    <a href="#" onClick={(e) => {
                                        e.preventDefault(); $('#investment').DataTable().ajax.reload();
                                        setReset(new Date().getTime());
                                    }} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="investment" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Name</th>
                                        <th className="wd-20p">Amount</th>
                                        <th className="wd-20p">Equity</th>
                                        <th className="wd-20p">Status</th>
                                        <th className="wd-20p">Date</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div className="modal-content tx-14">
                            <div className="modal-header">
                                <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mg-b-0 data-message">Empty</p>
                            </div>
                            <div className="modal-footer">
                                <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete</button>
                                <button type="button" className="btn btn-danger btn-block mt-0" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Investment;
